export default __webpack_public_path__ + "static/media/Bolo-Livedo.55969318.jpg";